<template>
  <div class="vendors_edit">
    <!-- <span>{{$route.params.id}}</span> -->
    <div class="search-line">
        <div class="left">
            <h3>{{`${$route.params.id === '0' ? `新建` : `编辑`}供应商`}}</h3>
        </div>
        <div class="right">
            <el-button type="primary" plain size="mini" @click.prevent="back"><i class="el-icon-back"></i>返回</el-button>
        </div>
    </div>
    <div class="vendors_center mt10">
        <el-tabs v-model="activeName">
            <el-tab-pane :label="`基本信息`" name="first">
                <el-form :model="form" :rules="rules" ref="form" label-width="100px">
                    <div class="divBorder">
                        <el-row>
                            <el-col :span="4">
                                <el-form-item :label="`名称`" prop="name" >
                                    <el-input :placeholder="`请输入`" v-model="form.name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item :label="`简称`" prop="short_name">
                                    <el-input :placeholder="`请输入`" v-model="form.short_name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item :label="`拼音`" prop="short_name">
                                    <el-input :placeholder="`请输入`" v-model="form.abc_code"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item :label="`类别`" prop="type">
                                    <el-select v-model="form.type" clearable filterable :placeholder="`请选择`">
                                        <el-option
                                            v-for="item in sorts"
                                            :key="item.value"
                                            :label="item.name"
                                            :value="item.value"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item :label="`联系人`" prop="contact_person">
                                    <el-input :placeholder="`请输入`" v-model="form.contact_person"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item :label="`电话`" prop="phone">
                                    <el-input :placeholder="`请输入`" v-model="form.phone"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="4">
                                <el-form-item :label="`网站`" prop="" >
                                    <el-input :placeholder="`请输入`" v-model="form.web"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item :label="`营业执照`" prop="">
                                    <el-input :placeholder="`请输入`" v-model="form.business_license"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="`营业期`" prop="period">
                                    <el-date-picker
                                        v-model="form.period"
                                        value-format="yyyy-MM-dd"
                                        type="daterange"
                                        :range-separator="`至`"
                                        :start-placeholder="`开始日期`"
                                        :end-placeholder="`结束日期`"
                                        @change="datechange">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item :label="`临时招标`" prop="is_temporary">
                                    <el-radio-group v-model="form.is_temporary">
                                        <el-radio :label="1">是</el-radio>
                                        <el-radio :label="0">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="`有效期`" prop="valid_time" >
                                    <el-date-picker
                                        v-model="form.valid_time"
                                        value-format="yyyy-MM-dd"
                                        type="daterange"
                                        :range-separator="`至`"
                                        :start-placeholder="`开始日期`"
                                        :end-placeholder="`结束日期`"
                                        >
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="`公司地址`" prop="" >
                                    <el-input :rows="4" type="textarea" :placeholder="`请输入`" v-model="form.address"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="`备注`" prop="" >
                                    <el-input :rows="4" type="textarea" :placeholder="`请输入`" v-model="form.description"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
                <div class="mt10">
                    <el-button size="small" type="primary" :loading="buttonLoading" @click="submitVendors">保存</el-button>
                    <el-button size="small" @click="back">取消</el-button>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
  </div>
</template>

<script>
// import PictureSelect from '@/components/common/PictureSelect/index.vue'
import { vendorsList, vendorsEdit } from '@/api.js' 
export default {
    name:'vendorsEdit',
    components: {
        // PictureSelect
    },
    data() {
        return {
            activeName:'first',
            form:{
                is_temporary:0,
            },
            loading:false,
            //上传照片
            show:false,
            typeOptions:[],
            sorts:[],
            buttonLoading:false,
            // 表单校验
            rules: {
                name:[
                    { required: true, message: `名称不能为空`, trigger: "blur" }
                ],
                short_name:[
                    { required: true, message: `简称不能为空`, trigger: "blur" }
                ],
                type:[
                    { required: true, message: `类别不能为空`, trigger: "blur" }
                ],
                // valid_time:[
                //     { required: true, message: "有效期不能为空", trigger: "blur" }
                // ],
                is_temporary:[
                    { required: true, message: `临时招标不能为空`, trigger: "blur" }
                ]
            },
        }
    },
    filters:{

    },
    created() {
        this.searchTypeOption();
        this.pageId = Number(this.$route.params.id)
            if (this.pageId) {
            this.getDetail(this.pageId)
        }
    },
    methods: {
        async getDetail(id) {
            // 获取详情
            const url = vendorsEdit.replace('{id}', id)
            const res = await this.$request('get', url, {})
            if (res) {
                this.form = res;
                this.$set(this.form,'valid_time',[res.valid_start_time ? res.valid_start_time :'', res.valid_end_time ? res.valid_end_time :'']);
                this.$set(this.form,'period',[res.period_start_time ? res.period_start_time :'', res.period_end_time ? res.period_end_time :''])
            }
        },
        //取消按钮
        back() {
            window.history.back();
        },
        //查询供应商类型
        searchTypeOption(){
            return this.$utils.getDict(305).then((typeOptions) => {
            if(typeOptions){
                this.sorts = typeOptions[305];
                // this.sorts.unshift({
                //     value: '0',
                //     name: '全部厂家'
                // })
                // this.queryParams.type = this.sorts[0].value
                }
            })
        },
        // 保存供应商信息
        submitVendors(){
            const url = vendorsList
            this.$refs["form"].validate(valid => {
            if (valid) {
                this.buttonLoading = true;
                this.form.period_start_time = this.form.period ? this.form.period[0] : '';
                this.form.period_end_time = this.form.period ? this.form.period[1] : '';
                this.form.valid_start_time = this.form.valid_time ? this.form.valid_time[0] : '';
                this.form.valid_end_time = this.form.valid_time ? this.form.valid_time[1] : '';
                if (this.form.id != null) {
                    this.$request('post', url, this.form).then(res => {
                    if(res){
                        this.$message.success(`修改成功`);
                        this.$router.push(`/basic/vendors/index`)
                    }
                    }).finally(() => {
                        this.buttonLoading = false;
                    });
                }else {
                    this.$request('post', url, this.form).then(res => {
                        if(res){
                            this.$message.success(`新增成功`);
                            // this.$router.push(`/basic/vendors/index`)
                        }
                    }).finally(() => {
                        this.buttonLoading = false;
                    });
                }
            }
            });
        },
        datechange(value){
            console.log(value)
        }
        
    }
}
</script>

<style lang="scss" scoped>
.vendors_edit{
    h3{
        color: #767676;
    }
    .vendors_center{
        background-color: white;
        border-radius: 10px;
        padding: 10px;
    }
    .divBorder{
        border: 2px solid #f9f9f9;
        border-radius: 10px;
        padding-top: 15px;
    }
}
</style>